<template>
    <div id="myPane">
        <div class="btn-box" v-if="config.buttonList">
            <div class="btn-box-start">
                <span v-for="(item, index) in config.buttonList"
                    :key="index">
                    <span v-if="item.ifHas" v-has="item.ifHas" >
                        <el-button
                            :disabled="item.disabled || false"
                            :loading="item.loading || false"
                            size="mini"
                            @click="btnEvent1(item.event)"
                            :class="'box-start-headBtn ' + (item.class || '')"
                            :icon="item.icon"
                            :type="item.type"
                        >{{ item.label }}</el-button>
                    </span>
                    <span v-else>
                        <el-button
                            :disabled="item.disabled || false"
                            :loading="item.loading || false"
                            size="mini"
                            @click="btnEvent1(item.event)"
                            :class="'box-start-headBtn ' + (item.class || '')"
                            :icon="item.icon"
                            :type="item.type"
                        >{{ item.label }}</el-button>
                    </span>
                </span>
            </div>
            <div slot="table-module-btn" class="btn-box-end">
                <slot name="table-module-btn"></slot>
                <el-tooltip v-if="config.configuration?false: true" class="item allocation-box" effect="dark" content="列配置" placement="bottom">
                <el-button size="mini" class="el-icon-setting" @click="getTitleList"></el-button>
                </el-tooltip>
                <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
                <configuration :checkedList="checkedList" :selectAllColumns="config.table.columns" ref="dialog"
                                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
                </el-dialog>
            </div>
        </div>
        <m-table
          ref="table"
          :popPrefix="popPrefix"
          :longPrefix="longPrefix"
          :verification="verification"
          :tableConfig="config.table"
          :tableData="totalData"
          :tableList="tableList"
          :loading="loading"
          @tab-advanced-search="tabAdvancedSearch"
          @row-db-click="rowDBClick"
          @row-click="rowClick"
          @save-data="saveData"
          @btnEvent="btnEvent"
          @onSelectionChange="selectChange"
          @element-change="elementChange"
          @column-filter-search="columnFilterSearch"
          @moreAction="moreAction"
          @btnClick="btnClick"
        ></m-table>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="12" class="page-text">
              <div v-if="config.table.selectBtn">
                已选<span class="text-color">{{checkedNum}}</span>项
              </div>
              <slot name="page-module-btn"></slot>
          </el-col>
          <el-col :span="12">
            <div class="page-box" @click.capture="pageClick">
                <m-page ref="page" :current-page="currentPage" :pageData="config.page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
            </div>
          </el-col>
        </el-row>
    </div>
</template>
<script>
/* eslint-disable no-magic-numbers */
import configuration from '@/modules/transport/bms/components/supplierPanel/configuration-list';
import mTable from '@/modules/transport/bms/components/supplierPanel/mTable';
import mPage from '@/modules/transport/bms/components/supplierPanel/mPage/Main';
import { getList } from '@/modules/transport/bms/components/supplierPanel/api';
import { mapGetters } from 'vuex';

export default {
    name: 'mPanel',
    components: { mTable, mPage, configuration },
    computed: {
        ...mapGetters(['menus'])
    },
    data() {
        return {
            checkedNum: 0,
            showModal: false,
            tableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: ''
        };
    },
    props: {
        config: Object,
        totalData: Array,
        pageTotal: Number,
        dataSourceUrl: String,
        pageID: String,
        searchId: String,
        currentPage: Number,
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        method: {
            type: String,
            default: 'get'
        },
        searchTotalTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        columnNum: Number,
        initSearchInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.handleChildren(childrens);
                }
            }
        },
        handleChildren(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        btnEvent(event, data) {
            if (event === 'view') {
                this.$emit('check-btn', data);
            } else if (event === 'delete') {
                this.$emit('del-btn', data);
            } else {
                this.$emit(`${event}-btn`, data);
            }
        },
        btnEvent1(event) {
            if (event === 'view') {
                this.$emit('check-btn');
            } else if (event === 'delete') {
                this.$emit('del-btn');
            } else {
                this.$emit(`${event}-btn`);
            }
        },
        photosTable(data) {
            this.$emit('photos-btn', data);
        },
        detailTable(data) {
            this.$emit('detail-btn', data);
        },
        uploadTable(data) {
            this.$emit('upload-btn', data);
        },
        // 表格中按钮触发事件
        checkTable(data) {
            this.$emit('check-btn', data);
        },
        editTable(data) {
            this.$emit('edit-btn', data);
        },
        separateTable(data) {
            this.$emit('separate-btn', data);
        },
        printTable(data) {
            this.$emit('print-btn', data);
        },
        delTable(data) {
            this.$emit('del-btn', data);
        },
        editorTable(data) {
            this.$emit('editor-btn', data);
        },
        removeTable(data) {
            this.$emit('remove-btn', data);
        },
        dispatchTable(data) {
            this.$emit('dispatch-btn', data);
        },
        pageClick(event) {
            this.$emit('page-click', event);
        },
        saveData(data) {
            this.$emit('saveData', data);
        },
        // 表单选项变化
        selectChange(data) {
            this.$emit('selectChange', data);
            this.checkedNum = data.length;
        },
        elementChange(data) {
            this.$emit('element-change', data);
        },
        rowDBClick(row) {
            this.$emit('row-db-click', row);
        },
        rowClick(row) {
            this.$emit('row-click', row);
        },
        // 搜索内容变化
        searchChange(data) {
            this.$refs.page.pageState = false;
            this.$emit('searchChange', data);
            this.$nextTick(() => {
                this.$refs.page.pageState = true;
            });
        },
        // 分页器改变触发事件
        pageChange(page) {
            this.$emit('pageChange', page);
        },
        sizeChange(size) {
            this.config.page.pageSize = size;
            this.$emit('sizeChange', size);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': this.resourceCode
                };
                getList.post(this.configurationUrl, pramas).then(() => {});
                this.tableList = tabelConfigList;
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle() {
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': this.resourceCode,
                    'subjectType': this.pageID
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = allColumns;
                    }
                }).catch(() => {
                    this.checkedList = allColumns;
                });
            }
        },
        initTitleList() {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
            } else {
                this.tableList = this.checkedList;
            }
        },
        getTitleList() {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch(data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance(prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        columnFilterSearch(data) {
            this.$refs.searchList.onSearchChange(data);
        },
        statusChange(status) {
            this.$refs.table.changeStatu(status);
        },
        changeLoading(status) {
            this.$refs.searchList.changeLoading(status);
        },
        moreAction(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        trajectoryTable(data) {
            this.$emit('trajectory-btn', data);
        },
        btnClick(val, index, row) {
            this.$emit('btnClick', val, index, row);
        }
    },
    mounted() {
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
    },
    watch: {
        totalData(newValue) {
            if (newValue.length) {
                // const el = this.$refs.table.$el;
                // const elTb = el.querySelector('.el-table');
                // const elTbHeight = elTb.getBoundingClientRect().height;
                // if (elTb.querySelector('.el-table__fixed-right')) {
                //     elTb.querySelector('.el-table__fixed-right').style.height = (elTbHeight - 7) + 'px';
                // }
                // if (elTb.querySelector('.el-table__fixed-body-wrapper')) {
                //     elTb.querySelector('.el-table__fixed-body-wrapper').style.height = (elTbHeight - 7 - 40) + 'px';
                // }
                const eTable = this.$refs.table.$refs.mNewTable || this.$refs.table;
                eTable.$refs.moduleTable && eTable.$refs.moduleTable.doLayout();
            }
        }
    }
};
</script>
<style lang="less">
#myPane {
    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }
    .m-table-wrapper {
        border: 0;
    }

    .m-table:after {
        width: 0;
    }

    .m-table:before {
        height: 0;
    }

    .m-table td,
    .m-table th {
        border-bottom: 0;
    }

    .zk-table {
        border: 0;
    }

    .zk-table__body,
    .zk-table__footer,
    .zk-table__header {
        border-collapse: initial;
    }
    .page-text{
      display: flex;
      >div{
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        margin-right: 10px;
        .text-color{
            color: #00BCBF;
            display: inline-block;
            width: 30px;
            text-align: center;
        }
      }
    }

    .btn-box{
        display: flex;
        margin-bottom: 10px;
        height: 28px;
        background: #FFFBF2;
        border: 1px solid #FFECE3;
        justify-content:space-between;
        .btn-box-start{
            .box-start-headBtn{
                color: #666 ;
                margin-left: 20px;
            }
        }
    }
    .row-bg{
      margin-top: 10px;
    }
    .allocation-box{
       margin-left: 10px;
    }
    .page-box{
        width: 100%;
        height: 100%;
    }
    /*.el-table {*/
    /*    min-height: calc(~ '100vh - 166px');*/
    /*    max-height: calc(~ '100vh - 166px');*/
    /*}*/
}
</style>
